import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    labelContainer: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      color: 'inherit',
    },
    buttonSearch: {
      background: 'transparent',
      border: 0,
      cursor: 'pointer',
      outline: 0,
      transition: 'all 200ms ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 36,
      marginLeft: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,

      '&:hover': {
        opacity: 0.8,
        backgroundColor: '#ddd',
      },
    },
    applyButton: {
      '& > svg': {
        color: theme.palette.success.main,
        transition: 'color 200ms ease',
      },

      '&:hover': {
        backgroundColor: theme.palette.success.main,
        '& > svg': {
          color: '#fff',
        },
      },
    },
    removeButton: {
      '& > svg': {
        color: theme.palette.error.main,
        transition: 'color 200ms ease',
      },

      '&:hover': {
        backgroundColor: theme.palette.error.main,
        '& > svg': {
          color: '#fff',
        },
      },
    },
    searchIcon: {
      color: '#0000008a',
    },
    closeIcon: {
      color: theme.palette.error.main,
    },
    searchContainer: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
    searchInput: {
      flex: 1,
      fontSize: 'inherit',
      maxWidth: '100%',
    },
  }),
);
